import Vue from 'vue'
import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css';
import '@/themes/theme-409EFF/index.css'

Vue.use(ElementUI)